import { AppBar, Avatar, Box, Stack, Toolbar, Typography } from "@mui/material";
import { useContext, useState } from "react";
import MenuButton from "./MenuButton";
import SideMenuMobile from "./SideMenuMobile";
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../utils/AuthContext";
import Global from "../utils/Global";
import getHomeLink from "../utils/getHomeLink";
import { logout } from "../services/AuthService";
import AlertDialog from "./AlertDialog";


export default function AppNavbar({ currentPage }) {
  const [open, setOpen] = useState(false);

  const { auth, setAuth } = useContext(AuthContext);

  // const [openLogoutDialog, setOpenLogoutDialog] = useState(false);

  const navigate = useNavigate();

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  // function getHomeLink() {
  //   if (auth?.user?.user_type === 'Agent') {
  //     return '/overview';
  //   } else if (auth?.user?.user_type === 'Admin') {
  //     return '/clients';
  //   }
  // }

  // function handleLogout() {
  //   localStorage.removeItem('agent-connect-api-token');
  //   localStorage.removeItem('agent-connect-current-user');


  //   setAuth({
  //     token: null,
  //     user: null
  //   });

  //   logout({ token: auth.token });

  //   navigate('/login');
  // }

  return (
    <AppBar elevation={0} sx={{ position: 'fixed', zIndex: 9997, backgroundColor: '#ededed' }}>
      <Toolbar variant="dense">
        <Stack
          direction="row"
          sx={{
            alignItems: 'center',
            flexGrow: 1,
            width: '100%',
            gap: 1,
          }}
        >
          <Stack
            direction="row"
            spacing={1}
            sx={{ justifyContent: 'center', mr: 'auto' }}
          >
            <Link to={getHomeLink(auth)} style={{ textDecoration: 'none', marginTop: 4 }} aria-label="Overview">
              <span style={{ display: 'block', fontSize: 20, color: '#000', fontWeight: 700, lineHeight: 1 }}>Agent</span>
              <span style={{ fontSize: 20, color: '#3328BF', fontWeight: 700, lineHeight: 1 }}>Connect+</span>
            </Link>
          </Stack>
          <Box sx={{
            display: {
              xs: 'none',
              md: 'flex'
            }, alignItems: 'center'
          }}
          >
            <Typography sx={{ color: '#000', mr: 2, fontWeight: 400 }}>{auth.user.full_name}</Typography>
            <Avatar
              src={Global.storageURL + auth.user.image}
              alt={auth.user.full_name}
            />
          </Box>

          <MenuButton sx={{
            display: {
              xs: 'block',
              md: 'none'
            }
          }} aria-label="menu" onClick={toggleDrawer(true)}>
            <MenuRoundedIcon />
          </MenuButton>
          <SideMenuMobile
            open={open}
            setOpen={setOpen}
            toggleDrawer={toggleDrawer}
            currentPage={currentPage} />
        </Stack>
      </Toolbar>
    </AppBar>
  );
}